import { connect } from 'react-redux'
import { IStoreState } from '../../types'
import {
  getServiceProgramProcessing,
  getServiceProgramProcessingError
} from '../../state/reducers/service-program/service-program'
import { createServiceProgram } from '../../state/actions/service-program/service-program'
import ServiceProgramAddModal from '../../components/global-settings/ServiceProgramAddModal'

const mapStateToProps = (state: IStoreState, ownProps: any) => {
  return {
    processing: getServiceProgramProcessing(state),
    processingError: getServiceProgramProcessingError(state),
    routeProps: ownProps
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    onCreate: (name: string) => {
      return dispatch(createServiceProgram(name))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ServiceProgramAddModal)



// WEBPACK FOOTER //
// ./src/containers/service-program/ServiceProgramAddModal.ts